const smoothScroll = (
  targetId: string,
  targetPosition: ScrollLogicalPosition = 'start',
) => {
  const targetElement = document.getElementById(targetId);

  targetElement!.scrollIntoView({ behavior: 'smooth', block: targetPosition });
};

export default smoothScroll;
